document.addEventListener('DOMContentLoaded', function() {
    // Get the elements
    const cartForm = document.getElementById('CartDrawer-Form');
    const checkoutButton = document.getElementById('CartDrawer-Checkout');
    const cartNoteTextarea = document.getElementById('CartDrawer-Note');

    // Function to enable/disable the checkout button based on textarea content
    function updateCheckoutButton() {
    if (cartNoteTextarea.value.trim() === '') {
        checkoutButton.disabled = true;
    } else {
        checkoutButton.disabled = false;
    }
    }

    // Initial update of the checkout button
    updateCheckoutButton();

    // Update the checkout button whenever the textarea content changes
    cartNoteTextarea.addEventListener('input', updateCheckoutButton);

    // Submit the form when the checkout button is clicked
    checkoutButton.addEventListener('click', function(event) {
    if (checkoutButton.disabled) {
        event.preventDefault();
    } else {
        cartForm.submit();
    }
    });
});